import { Route } from 'vue-router'

export default class TemplateContext {
  route: Route

  constructor(route:Route) {
    this.route = route
  }
}
